import React, { useEffect, useState } from "react";
import GymHopSection from "../GymHopSection";
import FooterSection from "../FooterSection";
import { getAllBusinessCall } from "../../../api/apiOperations";
import { PageContainer, BackButtonContainer, BackLink, ContentContainer } from "./styles";
import { useApi } from "../../../hooks";
import { useNavigate } from "react-router-dom";

const SelectGymView: React.FC = () => {
  const { request: getAllBusinessRequest } = useApi({
    apiFunc: getAllBusinessCall,
  });

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGyms = async () => {
      await getAllBusinessRequest(); 
      setLoading(false);
    };
    fetchGyms();
  }, []);

  return (
    <PageContainer>
      <BackButtonContainer>
        <BackLink onClick={() => navigate("/dashboard_members")}>
          ← Back to Dashboard
        </BackLink>
      </BackButtonContainer>
      <ContentContainer>
        {!loading && 
        <GymHopSection
          showSavings={true}
          backgroundColor="#f0e8dd"
        />}
      </ContentContainer>
      {/* <FooterSection></FooterSection> */}
    </PageContainer>
  );
};

export default SelectGymView;